"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = exports.PasswordIcon = exports.Option = exports.Label = exports.InvalidFeedback = exports.InputIcon = exports.InputField = exports.HelpText = exports.FormGroup = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _svg = require("../../svg");

var _validator = require("../../utils/validator");

var _generateRandomId = require("../../utils/generateRandomId");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../../styles/variables");

var _excluded = ["type", "invalidFeedback", "help", "placeholder", "name", "size", "inputOption", "inputIcon", "required", "onChange", "margin", "value"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Input component
 * @param {"submit"| "button"| "reset"} type
 * @param {string|undefined} invalidFeedback
 * @param {string|undefined} help
 * @param {string|undefined} placeholder
 * @param {string|undefined} name
 * @param {"l","s","xs"} size
 * @param {any} inputOption
 * @param {any} inputIcon
 * @param {boolean} required
 * @param {function} onChange
 * @param {boolean} margin
 * @param {any} value
 * @param {any} htmlAttributes
 * @returns {JSX.Element}
 * @constructor
 */
var sizes = {
  xs: function xs(inputIcon) {
    return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 12px;\n    height: 38px;\n    font-weight: 100;\n    text-indent: ", ";\n  "])), inputIcon ? "50px" : "12px");
  },
  s: function s(inputIcon) {
    return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    height: 48px;\n    text-indent: ", ";\n  "])), inputIcon ? "70px" : "23px");
  },
  l: function l() {
    return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 18px;\n    height: 60px;\n  "])));
  }
};
var labelSize = {
  xs: (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 12px;\n    transform: translate(-1px, 17px) scale(1);\n  "]))),
  s: (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: 16px !important;\n    transform: translate(-1px, 22px) scale(1);\n  "]))),
  l: (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-size: 18px !important;\n    transform: translate(-1px, 27px) scale(1);\n  "])))
};
var inputError = (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  border: 1px solid ", " !important;\n  border-radius: 10px;\n  z-index: 0;\n  &:focus {\n    border: 1px solid ", " !important;\n    border-radius: 10px;\n  }\n"])), _variables.colors.fire, _variables.colors.fire);

var FormGroup = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-family: IranSansX, sans-serif;\n  margin-bottom: ", ";\n  position: relative;\n"])), function (props) {
  return props.margin ? props.size === "s" ? "1rem" : "1.6rem" : "0";
});

exports.FormGroup = FormGroup;

var InputIcon = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 23px;\n  z-index: 1;\n  top: ", ";\n"])), function (props) {
  return props.size === "s" ? "19px" : "24px";
});

exports.InputIcon = InputIcon;

var Label = _styledComponents["default"].label(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  background-color: ", ";\n  color: ", ";\n  font-family: IranSansX, sans-serif;\n  line-height: 3px;\n  text-transform: capitalize;\n  float: right;\n  text-align: right;\n  right: ", ";\n  padding-left: 5px;\n  padding-right: 5px;\n  pointer-events: none;\n  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  transform-origin: top right;\n  transform: ", ";\n\n  //additional styles\n  ", ";\n  ", ";\n  ", ";\n"])), _variables.colors.ghost, _variables.colors.wolf, function (props) {
  return props.inputIcon ? "70px" : "10px";
}, function (props) {
  return props.fixed ? "translate(-1px, -1px) scale(0.75) !important" : "unset";
}, function (props) {
  return labelSize[props.size];
}, function (props) {
  return props.labelError && labelError;
}, function (props) {
  return props.required && labelRequired;
});

exports.Label = Label;

var InputField = _styledComponents["default"].input(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  position: relative;\n  border-radius: 10px;\n  box-shadow: none;\n  width: 100%;\n  font-family: IranSansX, sans-serif;\n  color: ", ";\n  line-height: 24px;\n  text-align: right;\n  direction: rtl;\n  outline: none;\n  background-color: ", ";\n  text-indent: ", ";\n\n  &:focus + ", " {\n    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    transform: translate(-1px, -1px) scale(0.75);\n  }\n\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n  }\n  //additional styles\n  ", ";\n  ", ";\n"])), _variables.colors.hare, _variables.colors.night, _variables.colors.ghost, function (props) {
  return props.size === "s" ? "0" : "18px";
}, Label, _variables.colors.swan, _variables.colors.whale, function (props) {
  return sizes[props.size](props.inputIcon);
}, function (props) {
  return props.inputError && inputError;
});

exports.InputField = InputField;
var labelError = (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", " !important;\n"])), _variables.colors.ghost, _variables.colors.fire);
var labelRequired = (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  &:after {\n    content: \"*\";\n    position: absolute;\n    color: red;\n    left: 0;\n    top: 0;\n  }\n"])));

var PasswordIcon = _styledComponents["default"].span(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: calc(45% - 22px);\n  right: auto;\n  cursor: pointer;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  left: 15px;\n"])));

exports.PasswordIcon = PasswordIcon;

var Option = _styledComponents["default"].div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  top: ", ";\n  left: 9px;\n"])), function (props) {
  return props.size === "l" ? "13px" : "6px";
});

exports.Option = Option;

var HelpText = _styledComponents["default"].div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  font-family: IranSansX, sans-serif;\n  width: 100%;\n  margin-top: 6px;\n  line-height: 13px;\n  direction: rtl;\n  text-align: right;\n  margin-right: 23px;\n  color: ", ";\n  font-size: ", ";\n"])), _variables.colors.wolf, function (props) {
  return props.size === "l" ? "14px" : "10px";
});

exports.HelpText = HelpText;

var InvalidFeedback = _styledComponents["default"].div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  font-family: IranSansX, sans-serif;\n  width: 100%;\n  margin-top: 6px;\n  line-height: 13px;\n  direction: rtl;\n  text-align: right;\n  margin-right: 23px;\n  color: ", ";\n  font-size: ", ";\n"])), _variables.colors.fire, function (props) {
  return props.size === "l" ? "14px" : "10px";
});

exports.InvalidFeedback = InvalidFeedback;

var TextInput = function TextInput(_ref) {
  var type = _ref.type,
      invalidFeedback = _ref.invalidFeedback,
      help = _ref.help,
      placeholder = _ref.placeholder,
      name = _ref.name,
      size = _ref.size,
      inputOption = _ref.inputOption,
      inputIcon = _ref.inputIcon,
      required = _ref.required,
      onChange = _ref.onChange,
      margin = _ref.margin,
      value = _ref.value,
      htmlAttributes = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      passwordVisibility = _useState2[0],
      setPasswordVisibility = _useState2[1],
      randomId = (0, _generateRandomId.generateRandomId)(20);

  var validate = function validate(e) {
    if (type === "tel") {
      if (e.target.value === "" || _validator.validator.validateNumber(e.target.value)) {
        onChange(e);
      }
    } else {
      onChange(e);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(FormGroup, {
    margin: margin,
    size: size
  }, inputIcon && /*#__PURE__*/_react["default"].createElement(InputIcon, {
    size: size
  }, inputIcon), /*#__PURE__*/_react["default"].createElement(InputField, _extends({
    "data-testid": "test-input",
    type: type && passwordVisibility ? "text" : type,
    name: name,
    id: "".concat(name).concat(randomId),
    value: value,
    onChange: function onChange(e) {
      return validate(e);
    },
    size: size,
    inputIcon: inputIcon,
    inputError: invalidFeedback
  }, htmlAttributes)), placeholder && /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: name,
    size: size,
    labelError: invalidFeedback,
    fixed: value.length,
    required: required
  }, placeholder), type === "password" && /*#__PURE__*/_react["default"].createElement(PasswordIcon, {
    onClick: function onClick() {
      return setPasswordVisibility(!passwordVisibility);
    },
    size: size
  }, passwordVisibility ? _svg.eyeIconHidden : _svg.eyeIconVisible), inputOption && /*#__PURE__*/_react["default"].createElement(Option, {
    size: size
  }, inputOption), help && /*#__PURE__*/_react["default"].createElement(HelpText, {
    size: size
  }, help), invalidFeedback && /*#__PURE__*/_react["default"].createElement(InvalidFeedback, {
    size: size
  }, invalidFeedback));
};

exports.TextInput = TextInput;
TextInput.propTypes = {
  /** Input type */
  type: _propTypes["default"].oneOf(["text", "email", "tel", "password"]),

  /** Input invalid feedback */
  invalidFeedback: _propTypes["default"].string,

  /** Input help text */
  help: _propTypes["default"].string,

  /** Input label text */
  placeholder: _propTypes["default"].string,

  /** Input name */
  name: _propTypes["default"].string,

  /** Input size */
  size: _propTypes["default"].oneOf(["l", "s", "xs"]),

  /** For required field */
  required: _propTypes["default"].bool,

  /** Handling input changes */
  onChange: _propTypes["default"].func,

  /** Input option (In float left such as Multi button)*/
  inputOption: _propTypes["default"].any,

  /** Input icon (In float right)*/
  inputIcon: _propTypes["default"].any,

  /** Input value*/
  value: _propTypes["default"].string,

  /** margin bottom*/
  margin: _propTypes["default"].bool
};
TextInput.defaultProps = {
  type: "text",
  size: "s",
  required: false,
  margin: true
};